export enum LevelEnum {
    INFO = "info",
    DANGER = "danger",
    WARN = "warning",
}
